import { useState, useEffect } from "react";
import axios from "axios";

const useLocationData = (formData) => {
  const [provinces, setProvinces] = useState([]);
  const [cityMunicipalities, setCityMunicipalities] = useState([]);
  const [barangays, setBarangays] = useState([]);

  const [loadingProvinces, setLoadingProvinces] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);
  const [loadingBarangays, setLoadingBarangays] = useState(false);

  const resetProvince = () => {
    setProvinces([]);
    resetCityMunicipalities();
  };

  const resetCityMunicipalities = () => {
    setCityMunicipalities([]);
    resetBarangay();
  };

  const resetBarangay = () => {
    setBarangays([]);
  };

  const fetchData = (url, key, setData, setLoading) => {
    setLoading(true);

    const cachedData = localStorage.getItem(key);
    if (cachedData) {
      setData(JSON.parse(cachedData));
      setLoading(false);
      return () => {};
    }

    const source = axios.CancelToken.source();

    axios
      .get(url, {
        cancelToken: source.token,
        headers: {
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      })
      .then((res) => {
        setData(res.data);
        localStorage.setItem(key, JSON.stringify(res.data));
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          console.error("Error fetching data:", err.message);
        }
      })
      .finally(() => setLoading(false));

    return () => source.cancel("Component unmounted or request canceled");
  };

  useEffect(() => {
    setLoadingProvinces(true);
    setLoadingCities(true);
    setLoadingBarangays(true);

    if (formData.region) {
      const url = `${process.env.REACT_APP_API_URL}/locations/?region=${formData.region}`;
      const cancelFetch = fetchData(
        url,
        `provinces_${formData.region}`,
        setProvinces,
        setLoadingProvinces
      );

      return cancelFetch;
    } else {
      resetProvince();
    }
  }, [formData.region]);

  useEffect(() => {
    if (formData.province) {
      setLoadingCities(true);
      setLoadingBarangays(true);

      const url = `${process.env.REACT_APP_API_URL}/locations/?region=${formData.region}&province=${formData.province}`;
      const cancelFetch = fetchData(
        url,
        `cities_${formData.region}_${formData.province}`,
        setCityMunicipalities,
        setLoadingCities
      );

      return cancelFetch;
    } else {
      resetCityMunicipalities();
    }
  }, [formData.province]);

  useEffect(() => {
    if (formData.cityMunicipality) {
      const url = `${process.env.REACT_APP_API_URL}/locations/?region=${formData.region}&province=${formData.province}&city_mun=${formData.cityMunicipality}`;
      const cancelFetch = fetchData(
        url,
        `barangays_${formData.region}_${formData.province}_${formData.cityMunicipality}`,
        setBarangays,
        setLoadingBarangays
      );

      return cancelFetch;
    } else {
      resetBarangay();
    }
  }, [formData.cityMunicipality]);

  return {
    provinces,
    cityMunicipalities,
    barangays,
    loadingProvinces,
    loadingCities,
    loadingBarangays,
  };
};

export default useLocationData;
